const SHOP_URL_FILTER_TYPE = {
  SHOP: 'shop',
  MY_ITEMS: 'my-items'
}

export { SHOP_URL_FILTER_TYPE }
